import { POSTURL } from "helpers/constant";
import { callApi } from "Apis";

export async function postList(data) {
  try {
    const response = await callApi({ url: POSTURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function postAdd(data) {
  try {
    const response = await callApi({ url: POSTURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getPostById(id) {
  try {
    const response = await callApi({ url: POSTURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updatePost(data) {
  try {
    const response = await callApi({ url: POSTURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deletePostById(id) {
  try {
    const response = await callApi({ url: POSTURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
